var teknion = teknion || {};
teknion.internal_luumca_reservations = (function(base_url, app_id, company_code) {
  var app_url = base_url + '/internal/luumca';

  var debug = function() {
    console.log('teknion.internal_luumca_reservations');
    console.log(app_url);
    console.log(app_id);
    console.log(company_code);
  };

  var index = function(customer_id, sort_by, order_by) {
    return $.ajax({
      type: 'GET',
      url: app_url + '/get_my_reservations',
      data: {
        customer_id: customer_id,
        company_code: company_code,
        appid: app_id,
        sort_by: sort_by,
        order_by: order_by
      },
      crossDomain: true,
      dataType: 'JSON',
      contentType: false,
    });
  };

  var get = function(customer_id, id) {
    return $.ajax({
      type: 'GET',
      url: app_url + '/reservation_details',
      crossDomain: true,
      data: {
        id: id,
        customer_id: customer_id,
        company_code: company_code,
        appid: app_id,
      },
    });
  };

  var create = function(formData) {
    // append app ID
    formData.append("appid", app_id);
    formData.append("company_code", company_code);
    return $.ajax({
      type: 'POST',
      url: app_url +'/add_reservation_from_luum',
      crossDomain: true,
      data: formData,
      contentType: false,
      processData: false,
    });
  };

  return {
    // debug: debug, // only uncomment for debugging purposes, ensure commented out in production
    index: index,
    get: get,
    create: create,
  };

})(teknion.base_url, teknion.app_id, teknion.company_code);
